import { render, staticRenderFns } from "./r-modal-window.vue?vue&type=template&id=59a9216a&scoped=true&"
import script from "./r-modal-window.vue?vue&type=script&lang=js&"
export * from "./r-modal-window.vue?vue&type=script&lang=js&"
import style0 from "./r-modal-window.vue?vue&type=style&index=0&id=59a9216a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a9216a",
  null
  
)

export default component.exports